import React from 'react';
import Required from './required';

class InputSelect extends React.PureComponent {
    renderInput() {
        return (
            <React.Fragment>
                {
                    this.props.label ?
                        <span>{this.props.label}{this.props.required ? <Required /> : null}</span>
                        : null
                }                
                <select
                    id={this.props.id}
                    name={this.props.name}
                    className={this.props.className}
                    required={this.props.required}
                    value={this.props.value}
                    onChange={this.props.onChange}
                >
                    {this.props.children}
                </select>
            </React.Fragment>
        );
    }

    render() {
        return (
            this.renderInput()
        );
    }
}

export default InputSelect;